export const DraggableItemTypes = {
    BOOK: 'draggable_book',
    CHAPTER: 'draggable_chapter',
    QUESTION: 'draggable_question',
};
